'use client'

import { ReactNode, useEffect } from 'react'

import '@/components/Context/DialogProvider/dialog.scss'
import { useSmoothScroll } from '@/components/hooks/useSmoothScroll'

export default function Dialog({
  children,
  show,
  closeButtonAction = null,
  afterSubmit,
  controlScroll = true,
}: {
  children: ReactNode
  show: boolean
  closeButtonAction?: null | (() => void)
  afterSubmit: () => void
  controlScroll?: boolean
}) {
  const { stop, start } = useSmoothScroll()

  useEffect(() => {
    if (!controlScroll) {
      return
    }

    if (show) {
      stop()
    } else {
      start()
    }

    return () => {
      start()
    }
  }, [show, controlScroll])

  if (!show) {
    return <></>
  }

  return (
    <>
      <div className={'c-dialog'}>
        <div className={'c-dialog__filter'}>
          <div className={'c-dialog__content'}>
            <div className={'c-dialog__content-inner'}>
              <p
                className={'c-dialog__close-button-anchor'}
                onClick={() => {
                  if (closeButtonAction != null) {
                    closeButtonAction()
                  }
                  afterSubmit()
                }}
              >
                <span className={'c-dialog__close-button'}>×</span>
              </p>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
